import { TApplicationState } from '../../types/redux';
import { IGeoUndergroundInfo } from '../../types/newbuilding/geo';

export function getUndergroundInfo(state: TApplicationState): IGeoUndergroundInfo[] | null {
  const {
    newbuilding: { geo },
  } = state;

  if (geo && geo.undergroundInfo && geo.undergroundInfo.length) {
    return geo.undergroundInfo;
  }

  return null;
}
